import { Modal } from "antd";
import React from "react";
import { ReactComponent as ArrowLeftRegularIcon } from "../../assets/icons/arrow-left-regular.svg";
import InputSelect from "../../molecules/input/input-select";
import useReceiptCustomisationStore from "../../stores/receipt-customisation/receipt-customisation-store";
import getBridges from "../../utils/bridges/get-bridges";
import { useMyAccessProfileV2 } from "../../apis/tryst/get-my-access-profile";
import { docListMassaged } from "./customisation-utls";

const CustomisationHeader = ({
  showSelector,
  isInsideProfile,
}: {
  showSelector: boolean;
  isInsideProfile: boolean;
}) => {
  const { navigate, changeClinic } = getBridges() || {};

  const { clinicId, setClinicId, hasChanged, selectedDoctorId } =
    useReceiptCustomisationStore();

  const { data: myAccessProfile } = useMyAccessProfileV2();
  const actualArray = docListMassaged();

  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  // Find selected doctor from the list
  const selectedDoctor = React.useMemo(() => {
    const currentDoctorId =
      selectedDoctorId || myAccessProfile?.loginmeta?.docid;
    return (
      actualArray?.doctors?.find((doc) => doc.oid === currentDoctorId) ||
      actualArray?.doctors?.[0]
    );
  }, [
    selectedDoctorId,
    myAccessProfile?.loginmeta?.docid,
    actualArray?.doctors,
  ]);

  const handleBackClick = () => {
    if (hasChanged) {
      setIsModalOpen(true);
    } else {
      history.back();
    }
  };

  const handleExit = () => {
    history.back();
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  // Update clinics to use selected doctor's clinics directly
  const clinics = React.useMemo(() => {
    if (!selectedDoctor?.clinics) return [];

    return selectedDoctor.clinics.map((clinic: any) => ({
      id: clinic.id,
      name: clinic.name,
    }));
  }, [selectedDoctor]);

  return (
    <>
      <div
        className="dr-sticky dr-top-0 dr-z-1 dr-bg-darwin-touch-neutral-0 dr-border-b border-darwin-neutral-100 p-16 flex justify-between items-center"
        style={!showSelector ? { height: "74px" } : {}}
      >
        <Modal
          title="Your changes have not been saved!"
          visible={isModalOpen}
          onOk={handleExit}
          onCancel={handleClose}
          cancelText="Go Back"
          okText="Yes, Exit"
        >
          <div>Are you sure you want to exit?</div>
        </Modal>

        <div className="flex items-center space-x-12">
          <ArrowLeftRegularIcon
            className="w-16 h-16 cursor-pointer"
            onClick={handleBackClick}
          />
          <div className="text-16 font-700 leading-6">
            Edit Receipt Template
          </div>
          {selectedDoctor && (
            <div className="text-14 text-darwin-neutral-600">
              for {selectedDoctor.name}
            </div>
          )}
        </div>

        {showSelector && clinics.length > 0 ? (
          <InputSelect
            options={clinics}
            onChange={(e) => {
              setClinicId({ clinicId: e.target.value });
              if (!isInsideProfile) {
                changeClinic?.(e.target.value);
                navigate?.(
                  "replace",
                  `/app/receipt-config/${e.target.value}?doctorId=${selectedDoctorId}`
                );
              }
            }}
            value={clinicId}
          />
        ) : null}
      </div>
    </>
  );
};

export default CustomisationHeader;
